import * as yup from 'yup';

import { STRINGS } from '@/constants/strings';

export type EnterEmailFormValues = {
  email: string;
};

export type LoginFormValues = {
  email: string;
  password: string;
};

const emailMessage = STRINGS.auth.enterEmail.validationEmail;
const requiredEmailMessage = STRINGS.auth.enterEmail.requiredEmail;
const invalidEmailMessage = STRINGS.auth.enterEmail.invalideEmail;

const passwordRequiredMessage = STRINGS.auth.login.validationPassword;

// const emailForgotPasswordMessage = STRINGS.auth.forgotPassword.validationEmail;

export const enterEmailSchema = yup.object({
  email: yup
    .string()
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, emailMessage)
    .email(emailMessage)
    .required(emailMessage),
});

export const loginSchema = yup.object({
  email: yup
    .string()
    .trim()
    .required(requiredEmailMessage)
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, invalidEmailMessage)
    .email(invalidEmailMessage),
  password: yup.string().required(passwordRequiredMessage),
});

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .trim()
    .required(requiredEmailMessage)
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, invalidEmailMessage)
    .email(invalidEmailMessage),
});
